import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import { selectedStopIconSvg } from '../../map/constants';
import { findSelectedStopInfo } from '../../map/redux/reducer';
import TaskBox from '../taskBox/TaskBox';
import cardStyles from '../Card.module.css';
import styles from './StopCard.module.css';
import { CONTAINERS } from '../cardNavigationComponent/cardNavigationRedux';
import ApiService from '../../../service/apiService';

const rowStyle = {
  padding: '12px 13px',
};

const headingStyle = {
  minWidth: '150px',
  display: 'inline-block',
};

const StopCard = React.memo(function StopCard({ stopId, container }) {
  const assetInfo = useSelector(findSelectedStopInfo(stopId));
  const [lastGeofenceEntryBy, setGeofenceEntry] = useState(null);
  const [lastGeofenceExitBy, setGeofenceExit] = useState(null);
  const stopName = assetInfo && assetInfo.stopName;
  const taskList = _.clone(_.get(assetInfo, 'taskList', []));
  taskList.sort((task1, task2) => (moment(task1.startTime).isAfter(moment(task2.startTime)) ? 1 : -1));
  useEffect(() => {
    async function fetchInfo() {
      setGeofenceEntry(null);
      setGeofenceExit(null);
      const response = await ApiService.getAssetsByIds([stopId]);
      if (response && response[0]) {
        setGeofenceEntry(response[0].lastGeofenceEntryBy);
        setGeofenceExit(response[0].lastGeofenceExitBy);
      }
    }
    fetchInfo();
  }, [stopId]);

  if (!assetInfo) return <div className="joyn2-grid map-view-card">Stop Not Available</div>;

  return (
    <div className={cardStyles.card}>
      <div className={cardStyles.cardHeader} style={{ paddingTop: '0px' }}>
        <div className={styles.mainHeader}>
          <img
            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(selectedStopIconSvg())}`}
            width="44"
            height="56"
            alt={stopName}
          />
          <span>{stopName}</span>
        </div>
      </div>
      <div>
        <div style={{ padding: '13px', backgroundColor: 'rgba(200, 244, 240, 0.3)' }}>Geofence Information</div>
        <div style={rowStyle}>
          <span style={headingStyle}>Last Entered By </span>
          <span>{lastGeofenceEntryBy ? `${lastGeofenceEntryBy.displayName}` : '-'}</span>
        </div>
        <div style={rowStyle}>
          <span style={headingStyle}>Last Entered At </span>
          <span>{lastGeofenceEntryBy ? `${new Date(lastGeofenceEntryBy.sampleTime).toLocaleString()}` : '-'}</span>
        </div>
        <div style={rowStyle}>
          <span style={headingStyle}>Last Exited By</span>
          <span>{lastGeofenceExitBy ? `${lastGeofenceExitBy.displayName}` : '-'}</span>
        </div>
        <div style={rowStyle}>
          <span style={headingStyle}>Last Exited At </span>
          <span>{lastGeofenceExitBy ? `${new Date(lastGeofenceExitBy.sampleTime).toLocaleString()}` : '-'}</span>
        </div>
      </div>
      <div style={{ padding: '13px', backgroundColor: 'rgba(200, 244, 240, 0.3)' }}>Tasks</div>
      <div className={cardStyles.cardContent}>
        {taskList.map((t) => {
          return <TaskBox task={t} key={t.id} container={container} />;
        })}
      </div>
    </div>
  );
});

export default StopCard;

StopCard.propTypes = {
  stopId: PropTypes.string.isRequired,
  container: PropTypes.oneOf(Object.values(CONTAINERS)).isRequired,
};
